import { c as _c } from "react/compiler-runtime";
import { IcoDotSmall16 } from '@onefootprint/icons';
import { Shimmer } from '@onefootprint/ui';
import { TIMELINE_GRID, TIMELINE_GRID_AREAS } from '@/components/timeline/components/timeline-item-row/timeline-item-row';
const AuditTrailTimelineSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="z-0 flex flex-col" aria-hidden={true}>{[0, 1, 2, 3].map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default AuditTrailTimelineSkeleton;
function _temp(i) {
  return <div key={i} className={`grid ${TIMELINE_GRID} ${TIMELINE_GRID_AREAS} pb-6`}><div className="hidden items-center h-8 pl-3 md:flex" style={{
      gridArea: "time"
    }}><Shimmer height="16px" width="72px" /></div><div className="flex items-center justify-center min-h-6 md:min-h-8" style={{
      gridArea: "icon"
    }}><IcoDotSmall16 color="quaternary" /></div><div className="flex items-center h-6 pl-2 md:h-8 md:pl-0" style={{
      gridArea: "content"
    }}><Shimmer height="16px" width="220px" /></div></div>;
}